'use strict';

var EventEmitter = require('events').EventEmitter;

var SceneArea = new Phaser.Class({

  Extends: Phaser.Scene,

  initialize:

  function SceneArea ()
  {
    Phaser.Scene.call(this, { key: 'sceneArea', active: false });
  },

  init: function(params){
    var self = this;
    this.params = params;

    this.sceneBoot = this.scene.get('sceneBoot');
    this.scaler = this.sceneBoot.scaler;

    this.sceneBoot.currentScene = 'sceneArea';

    this.sceneBoot.scaleMode = 'height';
    this.scaler.scaleMode = 'height';

    this.sceneBoot.windowResized = true;
    
    this.scene.bringToTop();

    this.startScroller = false;

    this.exhibitionsLocked = [];

    for(var key in EventEmitter.prototype){
      this.__proto__[key] = EventEmitter.prototype[key];
    }

    this.scrollerBounds = {
      top: 43,
      bottom: 1080 - 43,
    };
    this.dragSprites = [];
    
    this.allowDown = false;
    this.allowUp = true;

    this.on('dragstart-systems', function () {
      this.dragSprites.map(sprite => {
        sprite.keepData.x = sprite.x;
        sprite.keepData.y = sprite.y;
      });

      // if(this.autoScrollerTimer) {
      //   this.autoScrollerTimer.destroy();
      // }

      this.startScroller = false;
      if(this.reScrollerTimer) {
        this.reScrollerTimer.destroy();
      }
    });
  
    this.on('drag-systems', function(evt) {
      // if(evt.offset < 0 && this.allowUp == false)
      //   return;
      // if(evt.offset > 0 && this.allowDown == false)
      //   return;
      let v = 2;
      this.dragSprites.map(sprite => {
        sprite.y = sprite.keepData.y + evt.offset * v;
      });
    });
  
    this.on('dragend-systems', function(evt) {
      this.dragSprites.map(sprite => {
        sprite.alpha = sprite.keepData.alpha;
      });

      if(this.reScrollerTimer) {
        this.reScrollerTimer.destroy();
      }
      this.reScrollerTimer = this.time.delayedCall(800, function(){
        self.startScroller = true;
      }, this);
    }, this);
  
    this.on('wheel-systems', function(evt) {
      // if(evt.offset < 0 && this.allowUp == false)
      //   return;
      // if(evt.offset > 0 && this.allowDown == false)
      //   return;
      let v = 2;
      this.dragSprites.map(sprite => {
        sprite.keepData.y = sprite.y;
        sprite.y = sprite.keepData.y - evt.offset * v;
      });
    });
  },

  preload: function ()
  {

  },

  create: function ()
  {
    var self = this;
    var sprite, designX, designY;

    // designX = 0;
    // designY = 0;
    // var sprite = this.add.image(
    //   this.scaler.scaleBgX(designX, 'right'),
    //   this.scaler.scaleY(designY),
    //   'line_green'
    // );
    // sprite.setOrigin(1, 0);
    // this.scaler.scaleSprite(sprite);
    // sprite.keepData = {
    //   resized: true,
    //   xlocation: 'right',
    //   ylocation: 'top',
    //   designX: designX,
    //   designY: designY
    // };
    // this.lineGreenSprite = sprite;

    this.createDragSprite();

    designX = -1202;
    designY = 606;
    sprite = this.add.image(
      this.scaler.scaleBgX(designX, 'right'),
      this.scaler.scaleY(designY),
      'btn_left_blue');
    sprite.setOrigin(0.5, 0.5);
    this.scaler.scaleSpriteByHeight(sprite);
    sprite.keepData = {
      resized: true,
      xlocation: 'right',
      designX: designX,
      designY: designY,
      enableClick: true,
      alpha: 1,
    };
    this.btnLeftSprite = sprite;

    sprite.setInteractive();

    sprite.on("pointerdown", pointer => {
      this.btnLeftSprite.setAlpha(0.5);
      this.btnLeftSprite.isPressed = true;
    });

    sprite.on("pointerup", pointer => {
      this.btnLeftSprite.setAlpha(1.0);

      if(this.btnLeftSprite.isPressed) {
        this.back();
      }

      this.btnLeftSprite.isPressed = false;
    });

    var totalHeight = 0;
    for(var i = 0; i < 24; i ++) {
      (function(i){
        designX = -1030;
        designY = 43 + totalHeight;

        var sprite = self.add.image(
          self.scaler.scaleBgX(designX, 'right'),
          self.scaler.scaleY(designY),
          'system_name_' + i%12
        );
        sprite.setOrigin(0, 0);
        self.scaler.scaleSprite(sprite);
        sprite.keepData = {
          resized: true,
          xlocation: 'right',
          designX: designX,
          designY: designY,
          enableClick: true,
          alpha: 1,
        };
        self.dragSprites.push(sprite);

        totalHeight += sprite.height + 40;

        sprite.setInteractive({ draggable: true });

        sprite.on("pointerdown", pointer => {
          // sprite.setAlpha(0.5);
          sprite.isPressed = true;
        });
    
        sprite.on("pointerup", pointer => {
          // sprite.setAlpha(1.0);
    
          if(sprite.isPressed && self.dragMaxOffset < 5){
            self.selectSystem(i%12);
          }

          sprite.isPressed = false;
        });
      }(i));
    }

    this.dragSprites.forEach(sprite => {
      sprite.setInteractive({ draggable: true });

      sprite.on('dragstart', function (pointer, dragX, dragY) {
        // console.log(`drag start.. ${pointer.x} ${pointer.y}`);
        self.dragMaxOffset = 0;
        sprite.keepData.x = sprite.x;
        sprite.keepData.y = sprite.y;
        this.emit('dragstart-systems');
      }, this);
    
      sprite.on('drag', function (pointer, dragX, dragY) {
        //console.log(dragX);
        // check whether out area
        if(self.scaler.getDirection() == 'Horizontal'){
          let offset = dragY - sprite.keepData.y;
          (Math.abs(offset) > self.dragMaxOffset) && (self.dragMaxOffset = Math.abs(offset));

          this.emit('drag-systems', {offset: offset});
        } else {
          let offset = (sprite.keepData.x - dragX);
          (Math.abs(offset) > self.dragMaxOffset) && (self.dragMaxOffset = Math.abs(offset));

          this.emit('drag-systems', {offset: offset});
        }
    
      }, this);
    
      sprite.on('dragend', function (pointer, dragX, dragY) {
        // console.log('drag end');
        this.emit('dragend-systems');
      }, this);
    
      sprite.on('wheel', function (pointer, deltaX, deltaY, deltaZ) {
        this.emit('wheel-systems', {offset: deltaY * 0.4});
      }, this);  
    });

    this.input.on('pointerup', function () {
      utils.updateButtonsAlpha(this);
    }, this);

    utils.disableAllButtons(this);

    if(this.params.noAnimation) {
      this.enterAnimation(function() {
        if(self.params.isSystem) {
          self.scene.pause();
        } else {
          self.scene.get('sceneAnimation').show();
        }

        utils.enableAllButtons(self);

        self.autoScroller();
        self.reScrollerTimer = self.time.delayedCall(0, function(){
          self.startScroller = true;
        }, this);
      });
    } else {
      utils.enableAllButtons(self);

      self.autoScroller();
      self.reScrollerTimer = self.time.delayedCall(900, function(){
        self.startScroller = true;
      }, this);
    }
    
  },

  update: function() {
    // this.checkEnding();
    this.checkLoopScroller();
  },

  resized: function () {
    var phaserElements = this.children.list;
    for(var i = 0; i < phaserElements.length; i ++){
      var s = phaserElements[i];
      if(s.keepData && s.keepData.resized == true){
        if(s.type == 'Video'){
          s.x = this.scaler.scaleX(this.scaler.designRefWidth()/2);
          s.y = this.scaler.scaleY(this.scaler.designRefHeight()/2);
          this.scaler.scaleSpriteByMax(s);
        } else{
          if(s.keepData.xlocation && s.keepData.xlocation == 'center'){
            s.x = this.scaler.scaleBgX(s.keepData.designX, 'center');
          } else if(s.keepData.xlocation && s.keepData.xlocation == 'right'){
            s.x = this.scaler.scaleBgX(s.keepData.designX, 'right');
          } else{
            s.x = this.scaler.scaleBgX(s.keepData.designX);
          }

          if(s.keepData.ylocation && s.keepData.ylocation == 'bottom'){
            s.y = this.scaler.scaleY(this.scaler.designRefHeight() + s.keepData.designY);
          } else if(s.keepData.ylocation && s.keepData.ylocation == 'center'){
            s.y = this.scaler.scaleY(this.scaler.designRefHeight()/2 + s.keepData.designY);
          } else{
            s.y = this.scaler.scaleY(s.keepData.designY);
          }
          
          if(s.keepData.fill){
            this.scaler.scaleSpriteFill(s);
          } else{
            this.scaler.scaleSprite(s);
          }

          if(s.keepData.displayWidth){
            s.displayWidth = s.keepData.displayWidth * this.scaler.hScale();
          }
        }
      }
    }

    var w = this.scaler.width;
    var h = this.scaler.height;
    if(this.scaler.width < this.scaler.height) {
      w = this.scaler.height;
      h = this.scaler.width;
    }
    if(w/h < 1.45) {
      this.scene.get('sceneTitle').cameras.main.alpha = 0;

      this.scene.get('sceneAnimation').animationSprite.alpha = 0.001;
    } else {
      this.scene.get('sceneTitle').cameras.main.alpha = 1;

      this.scene.get('sceneAnimation').animationSprite.alpha = 1;
    }
  },

  createDragSprite: function () {
    const self = this;
    let designX = 0;
    let designY = 0;
    let sprite = this.add.rectangle(
      this.scaler.scaleBgX(this.scaler.designRefWidth()/ + designX),
      this.scaler.scaleY(designY),
      1030,
      1080,
      0xff0000,
      0);
    sprite.setOrigin(1, 0);
    this.scaler.scaleSprite(sprite);
    sprite.keepData = { 
      resized: true,
      designX: designX,
      designY: designY,
      xlocation: 'right',
    };


    sprite.setInteractive({ draggable: true });

    sprite.on('dragstart', function (pointer, dragX, dragY) {
      // console.log(`drag start.. ${pointer.x} ${pointer.y}`);
      sprite.keepData.x = sprite.x;
      sprite.keepData.y = sprite.y;
      this.emit('dragstart-systems');
    }, this);
  
    sprite.on('drag', function (pointer, dragX, dragY) {
      //console.log(dragX);
      // check whether out area
      if(self.scaler.getDirection() == 'Horizontal'){
        this.emit('drag-systems', {offset: dragY - sprite.keepData.y});
      } else{
        this.emit('drag-systems', {offset: (sprite.keepData.x - dragX)});
      }
  
    }, this);
  
    sprite.on('dragend', function (pointer, dragX, dragY) {
      // console.log('drag end');
      this.emit('dragend-systems');
    }, this);
  
    sprite.on('wheel', function (pointer, deltaX, deltaY, deltaZ) {
      this.emit('wheel-systems', {offset: deltaY * 0.4});
    }, this);
  },

  selectSystem: function(systemIndex) {
    window.custom.selected.systemIndex = systemIndex;
    this.scene.pause();
    this.scene.launch('sceneSystemPreface', { systemIndex: systemIndex });

    this.scene.get('sceneAnimation').hide();
  },

  back: function(){
    utils.disableAllButtons(this);

    this.scene.get('sceneAnimation').hide();
    this.backAnimation();
    this.scene.get('sceneTitle').outAnimation();
    this.scene.launch('sceneEnter');
  },

  nextPage: function(exhibitionIndex, sidebarIndex){
    utils.disableAllButtons(this);
    window.custom.selected.exhibitionIndex = exhibitionIndex;
 
    this.toMainPage(exhibitionIndex);
    this.scene.get('sceneSideBar').updateSidebarText(sidebarIndex);
    this.scene.get('sceneLoading').setLoadingProgress(0);
  },

  checkEnding: function () {
    var self = this;
    var minY, maxY;
    var sprites = this.dragSprites;
    if(sprites.length <= 0)
      return;
    minY = sprites[0].y;
    maxY = sprites[sprites.length - 1].y + sprites[sprites.length - 1].displayHeight;

    var top = this.scaler.scaleY(this.scrollerBounds.top);
    var bottom = this.scaler.scaleY(this.scrollerBounds.bottom);
  
    if(minY >= top && maxY < bottom){
      this.allowDown = false;
      this.allowUp = false;
      return;
    }
  
    if(minY >= top){
      this.allowDown = false;
  
      var offset = minY - top;
      sprites.map(sprite => {
        sprite.y -= offset; 
      });
  
    } else{
      this.allowDown = true;
    }
  
    if(maxY <= bottom){
      this.allowUp = false;
  
      if(minY < top){
        var offset = bottom - maxY;
        sprites.map(sprite => {
          sprite.y += offset; 
        });
      }
  
    } else{
      this.allowUp = true;
    }

    if(this.lastAllowUp && this.allowUp == false) {
      if(this.restartScrollerTimer) {
        this.restartScrollerTimer.destroy();
      }
      if(this.autoScrollerTimer) {
        this.autoScrollerTimer.destroy();
      }
      this.restartScrollerTimer = this.time.delayedCall(3000, function(){  
        self.restartScrollerAnimation();
      }, this);
    }

    if(this.lastAllowUp == false && this.allowUp == true) {
      if(this.restartScrollerTimer) {
        this.restartScrollerTimer.destroy();
      }
      this.autoScroller();
    }

    this.lastAllowUp = this.allowUp;
  },

  checkLoopScroller: function() {
    var sprites = this.dragSprites;

    var minIndex = 0;
    var maxIndex = 0;
    var min = sprites[minIndex].y;
    var max = sprites[maxIndex].y;
    sprites.forEach((sprite, index) => {
      if(sprite.y < min) {
        minIndex = index;
        min = sprite.y;
      }

      if(sprite.y > max) {
        maxIndex = index;
        max = sprite.y;
      }
    });

    if(sprites[minIndex].y + sprites[minIndex].displayHeight < -1080 * this.scaler.vScale()) {
      sprites[minIndex].y = sprites[maxIndex].y + sprites[maxIndex].displayHeight + 40 * this.scaler.vScale();
    }

    if(sprites[minIndex].y > -1080 * this.scaler.vScale()) {
      sprites[maxIndex].y = sprites[minIndex].y - sprites[maxIndex].displayHeight - 40 * this.scaler.vScale();
    }
  },

  enterAnimation: function(func) {
    var duration = GC.animationDuration;

    var sprites = [];
    this.dragSprites.forEach(sprite => {
      sprites.push(sprite);
    });
    // sprites.push(this.lineGreenSprite);
    sprites.push(this.btnLeftSprite);
    this.tweens.add({
      targets: sprites,
      alpha: {
        start: 0,
        to: 1,
      },
      duration: duration,
      delay: 600,
      ease:'Linear',
      repeat: 0,
      yoyo: false,
      onComplete: function () {
        if(func) {
          func();
        }
      },
    });
  },

  backAnimation: function() {
    var self = this;
    var duration = GC.animationDuration;

    var phaserElements = this.children.list;
    phaserElements.forEach(sprite => {
      if(sprite.keepData.resized) {
        sprite.keepData.resized = false;
      }
    });
    
    this.tweens.add({
      targets: this.cameras.main,
      alpha: {
        start: 1,
        to: 0
      },
      duration: duration,
      delay: 0,
      ease: 'Linear',
      repeat: 0,
      yoyo: false,
      onComplete: function () {
        self.scene.stop();
      },
    }); 
  }, 
  
  autoScroller: function() {
    if(this.autoScrollerTimer) {
      this.autoScrollerTimer.destroy();
    }
    this.autoScrollerTimer = this.time.addEvent({
      delay: 1000/25,
      callback: function(){
        if(this.startScroller) {
          this.dragSprites.forEach(sprite => {
            sprite.y -= this.scaler.vScale() * 1.4;
          });
        }

        if(this.scene.isActive('sceneAnimation')) {
          this.scene.get('sceneAnimation').setFrame();
        }
      },
      callbackScope: this,
      loop: true
    });

  },

  restartScrollerAnimation: function() {
    var self = this;
    var duration = GC.animationDuration;
    this.tweens.add({
      targets: this.dragSprites,
      alpha: {
        start: 1,
        to: 0,
      },
      duration: duration,
      delay: 0,
      ease:'Linear',
      repeat: 0,
      yoyo: false,
      onComplete: function () {
        self.dragSprites.forEach(sprite => {
          sprite.y = self.scaler.scaleY(sprite.keepData.designY);
        });
        self.tweens.add({
          targets: self.dragSprites,
          alpha: {
            start: 0,
            to: 1,
          },
          duration: duration,
          delay: 0,
          ease:'Linear',
          repeat: 0,
          yoyo: false,
          onComplete: function () {
            self.autoScroller();
          },
        });
      },
    });
  },
});
export default SceneArea;